module.exports = __webpack_public_path__ + "img/Hot2.cd748218.svg";